import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
import _typeof from "@babel/runtime/helpers/typeof";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var c = Object.defineProperty;
var i = function i(e, o, r) {
  return o in e ? c(e, o, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : e[o] = r;
};
var a = function a(e, o, r) {
  return i(e, _typeof(o) != "symbol" ? o + "" : o, r);
};
import { objectToQuery as l } from "../node_modules/.pnpm/@mx_util@2.1.17/node_modules/@mx/util/object-to-query.js";
import t from "../node_modules/.pnpm/@mx_fsp-mweb-env@0.125.0/node_modules/@mx/fsp-mweb-env/dist/index.esm.js";
import f from "../node_modules/.pnpm/@mx_fsp-mweb-request@0.125.0/node_modules/@mx/fsp-mweb-request/dist/index.esm.js";
var s = /*#__PURE__*/function (_Error) {
  function s(r, n, m) {
    var _this;
    _classCallCheck(this, s);
    _this = _callSuper(this, s, [r]);
    a(_this, "level");
    a(_this, "code");
    _this.level = n, _this.code = m, Object.setPrototypeOf(_this, s.prototype);
    return _this;
  }
  _inherits(s, _Error);
  return _createClass(s);
}(/*#__PURE__*/_wrapNativeSuper(Error));
var u = ["401", "402", "403", "404", "405", "406", "4001", "100001", "999999"];
function p(e, o) {
  if (u.find(function (n) {
    return n === "".concat(e.code);
  })) {
    sessionStorage.setItem("login", "1");
    return;
  }
  if (!o) switch (e.level) {}
}
function h(_x) {
  return _h.apply(this, arguments);
}
function _h() {
  _h = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
    var o, r;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return f(_objectSpread(_objectSpread({}, e), {}, {
            transformRequest: [function (r) {
              var n = _objectSpread(_objectSpread({
                nb_platform: t.commonParams.platform,
                nb_appversion: t.commonParams.version,
                nb_app: t.commonParams.app,
                nb_uuid: t.commonParams.uuid,
                nb_location: t.commonParams.location,
                nb_fingerprint: t.commonParams.fingerprint,
                nb_ci: t.commonParams.cityId,
                from: t.from
              }, t.commonParams), r);
              return l(n);
            }]
          }));
        case 3:
          o = _context.sent;
          if (!o.error) {
            _context.next = 7;
            break;
          }
          r = o.error;
          throw new s(r.message, r.level, r.code);
        case 7:
          return _context.abrupt("return", o.data);
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](0);
          throw p(_context.t0, e.noShowErrorToast || !1), _context.t0;
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 10]]);
  }));
  return _h.apply(this, arguments);
}
export { h as serviceCallback };
